module.exports = __webpack_public_path__ + "img/Frame_11.50b41a6e.png";